import { global_hooks } from 'src/globals';
import { create_div } from 'js/utils';

import './loading.scss';

global_hooks.on('listing/init', init);
function init(listing) {
	const icon = create_div('loading_icon', listing.container);

	const hide_indicator = () => {
		icon.dataset.state = 'hide';
	};

	const show_indicator = () => {
		icon.dataset.state = 'show';
	};

	const loading = (minimum_load_time = 600) => {
		show_indicator();

		return {
			end: (callback = null) => {
				setTimeout(() => {
					hide_indicator();

					if (typeof callback === 'function') {
						callback();
					}
				}, minimum_load_time);
			},
		};
	};

	listing.loading = loading;
}
